import React, { ReactNode } from 'react'
import { Me } from 'service/user'

export const AuthGuard = ({
  userInfo,
  children,
}: {
  userInfo: Me | undefined
  children: ReactNode
}) => {
  if (!userInfo) return null
  return <>{children}</>
}
